// Copyright (c) Move Closer 2022.

import gql from 'graphql-tag'

import { QueryRegistry } from '../../../contexts'
import { LOYALTY_FRAGMENT } from './graphql/fragments'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const loyaltyQueries: QueryRegistry = {
  fetchLoyalty: {
    type: 'query',
    query: gql`
      ${LOYALTY_FRAGMENT}
      query customer {
        customer {
          ...LoyaltyFragment
        }
      }
    `,
    meta: {}
  },
  updateLoyalty: {
    type: 'mutation',
    query: gql`
      ${LOYALTY_FRAGMENT}
      mutation($payload: CustomerInput!) {
        updateLoyalty(
          input: $payload
        ) {
          customer {
            ...LoyaltyFragment
          }
        }
      }`,
    meta: {
      noAuth: false
    }
  }
}
